import { useState, useEffect } from "react";
import FilterSingle from "./FilterSingle";

function Filter({ params = {} }) {
  const { filters, i18n } = params;
  const [currFilters, setCurrFilters] = useState([]);

  useEffect(() => {
    //build query string
    prepareQuery();
    //console.log(i18n);
  }, []);

  const prepareQuery = () => {
    var cf = filters;

      cf?.forEach((item, index) => {
        item.values.forEach((itemSel, indexSel) => {
          if (item.current?.split("-").find((i) => i == itemSel.slug)) {
            //console.log("here" + itemSel.slug);
            cf[index].values[indexSel] = { ...itemSel, selected: true };
          }
        });
      });
    

    //console.log(cf);
    setCurrFilters(cf);
  };

  const updateQuery = (name, value) => {
    var cf = [];
    Object.assign(cf, currFilters);
    
      cf.forEach((item, index) => {
        if (name === item.name) {
          item.values.forEach((itemSel, indexSel) => {
            if (itemSel.slug === value) {
              //console.log("here again:" + value);
              cf[index].values[indexSel] = {
                ...itemSel,
                selected: !itemSel.selected,
              };
            }
          });
        }
      });
    

    setCurrFilters(cf);
    //console.log("cf:", cf);
    //console.log(buildHref());
    //return qp;
    //console.log('qp:', qp);
  };

  const buildHref = () => {
    var first = true;
    var href_param = "";
    currFilters.map((item) => {
      var href_slugs = "";
      var added = false;
      item.values.map((value) => {
        if (value.selected) {
          href_slugs += (added ? "-" : "") + value.slug;
          added = true;
        }
      });
      if (href_slugs) {
        href_param += (first ? "?" : "&") + item.name + "=" + href_slugs;
        first = false;
      }
    });
    return href_param;
  };

  const processQuery = () => {
    const href = buildHref();
    //console.log(window.location.pathname);
    //console.log(href);
    window.location.assign(
      window.location.pathname + buildHref() + '#trojniak-shop'
    );
  };

  //console.log(params);
  return (
    <div id="filter">
      {currFilters?.map((item) => (
        <FilterSingle
          name={item.name}
          current={item.current}
          data={item.values}
          //query={query}
          //queryParams={queryParams}
          currFilters={currFilters}
          updateQuery={updateQuery}
          processQuery={processQuery}
          i18n={i18n}
        ></FilterSingle>
      ))}
    </div>
  );
}
export default Filter;
